import React from "react";
import "../../Styles/featured.css";
import { FiMapPin } from "react-icons/fi";
import { PiBathtubBold } from "react-icons/pi";
import { FaBed } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { FaCar } from "react-icons/fa";
import { RiShareForwardBoxLine } from "react-icons/ri";
import { TbCopyPlusFilled } from "react-icons/tb";
import { IoFlash } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Featured = ({ featuredProperty }) => {
  const navigate = useNavigate()
  return (
    <>
      <section className="featured-section">
        <div className="container">
          <div className="row">
            <div className="col-12 property-heading-col">
              <h3>Featured Properties</h3>

              <a onClick={() => navigate(`/property-listing?is_featured=1`)} style={{ cursor: "pointer" }}>
                <h5>
                  See All Properties
                  <span>
                    <img src="/images/btn-arrow.png" alt="Arrow Icon" />
                  </span>
                </h5>
              </a>
            </div>
          </div>
          <div className="row featured-row">
            {featuredProperty &&
              featuredProperty.map((item, i) => (
                <div className="col-sm-12 col-md-12 col-lg-6">
                  <div className="featured-box" onClick={() =>
                    navigate(`/property-details/${item.slug}-${item.id}`)
                  } style={{ cursor: "pointer" }}>
                    <div className="featured-box-bg" style={{ backgroundImage: `url(${item.image})` }}>
                      <p>
                        <span>
                          <IoFlash />
                        </span>
                        Featured
                      </p>
                    </div>
                    <div className="featured-box-title">
                      <h5>{item.title}</h5>
                      <p>
                        <span>
                          <FiMapPin />
                        </span>
                        {item.address}
                      </p>
                      <div className="d-flex justify-content-between">
                        <div className="featured-box-details">
                          <p>
                            <span>
                              <FaBed />
                            </span>
                            {item.badroom} Beds
                          </p>
                          <p>
                            <span>
                              <PiBathtubBold />
                            </span>
                            {item.bathroom} Baths
                          </p>
                        </div>
                        <div className="featured-box-details">
                          <p>
                            <span>
                              <FaRegCopy />
                            </span>
                            {item.area_sqft} sqft
                          </p>
                          <p>
                            <span>
                              <FaCar />
                            </span>
                            {item.garage_spaces} Garages
                          </p>
                        </div>
                      </div>
                      <div className="featured-btn">
                        <div>
                          <button>View More</button>
                        </div>
                        <div className="featured-btn-icons">
                          <RiShareForwardBoxLine />
                          <TbCopyPlusFilled />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Featured;
